import { zSchema } from "@zeal/common";

export const postSshKeyRotationActivateResponseSchema = zSchema.object({
  id: zSchema.string(),
  state_code: zSchema.string(),
  key_version: zSchema.number(),
  status: zSchema.string(),
  activated_at: zSchema.union([zSchema.string(), zSchema.date()]),
});

export type TPostSshKeyRotationActivateResponseSchema = zSchema.infer<
  typeof postSshKeyRotationActivateResponseSchema
>;
